<template>
  <div class="auth-wrapper d-flex align-items-center justify-content-center min-vh-100 bg-light">

    <b-card
      class="auth-card shadow border-0"
      style="max-width: 440px; width: 100%; border-radius: 12px;"
    >

      <!-- Header -->
      <div class="text-center mb-4">
        <div class="mb-2">
          <span class="badge badge-primary px-3 py-2">
            Account Activation
          </span>
        </div>

        <h4 class="font-weight-bold mb-1">Set Your Password</h4>
        <small class="text-muted">
          Secure your account by creating a password
        </small>
      </div>

      <form @submit.prevent="submit">

        <!-- Password -->
        <b-form-group label="Password" label-class="font-weight-600">

          <b-input-group>
            <b-form-input
              :type="showPassword ? 'text' : 'password'"
              v-model="password"
              required
              minlength="8"
              placeholder="Enter password"
              @input="checkMatch"
            />

            <b-input-group-append>
              <b-button
                variant="outline-secondary"
                @click="showPassword = !showPassword"
                type="button"
              >
                <i :class="showPassword ? 'bi bi-eye-slash' : 'bi bi-eye'"></i>
              </b-button>
            </b-input-group-append>
          </b-input-group>

          <small class="text-muted">
            Minimum 8 characters required
          </small>

        </b-form-group>

        <!-- Confirm Password -->
        <b-form-group label="Confirm Password" label-class="font-weight-600">

          <b-input-group>
            <b-form-input
              :type="showConfirmPassword ? 'text' : 'password'"
              v-model="confirmPassword"
              required
              placeholder="Confirm password"
              @input="checkMatch"
            />

            <b-input-group-append>
              <b-button
                variant="outline-secondary"
                @click="showConfirmPassword = !showConfirmPassword"
                type="button"
              >
                <i :class="showConfirmPassword ? 'bi bi-eye-slash' : 'bi bi-eye'"></i>
              </b-button>
            </b-input-group-append>
          </b-input-group>

          <!-- Match feedback -->
          <div v-if="confirmPassword" class="mt-2 small">
            <span :class="passwordsMatch ? 'text-success' : 'text-danger'">
              <i
                :class="passwordsMatch ? 'bi bi-check-circle-fill' : 'bi bi-x-circle-fill'"
                class="mr-1"
              ></i>
              {{ matchMessage }}
            </span>
          </div>

        </b-form-group>

        <!-- Submit -->
        <b-button
          type="submit"
          variant="primary"
          block
          class="mt-3 py-2"
          :disabled="loading || !canSubmit"
        >
          <b-spinner small v-if="loading" class="mr-2"></b-spinner>
          {{ loading ? "Activating..." : "Activate Account" }}
        </b-button>

      </form>

    </b-card>

  </div>
</template>

<script>
import { userService } from "@/api/user.service";
import swal from "sweetalert";

export default {
  name: "ActivateAccount",

  data() {
    return {
      token: null,
      password: "",
      confirmPassword: "",
      loading: false,

      showPassword: false,
      showConfirmPassword: false,

      passwordsMatch: false,
    };
  },

  computed: {
    canSubmit() {
      return (
        this.password.length >= 8 &&
        this.passwordsMatch
      );
    },

    matchMessage() {
      if (!this.confirmPassword) return "";
      return this.passwordsMatch
        ? "Passwords match"
        : "Passwords do not match";
    },

    matchClass() {
      return this.passwordsMatch ? "text-success" : "text-danger";
    },
  },

  mounted() {
    this.token = this.$route.params.token;

    if (!this.token) {
      swal({
        icon: "error",
        text: "Invalid activation link.",
      }).then(() => {
        this.$router.push("/");
      });
    }
  },

  methods: {
    checkMatch() {
      this.passwordsMatch =
        this.password && this.password === this.confirmPassword;
    },

    async submit() {
      this.checkMatch();

      if (!this.passwordsMatch) {
        swal({
          icon: "error",
          text: "Passwords do not match.",
        });
        return;
      }

      this.loading = true;

      try {
        await userService.setPassword({
          token: this.token,
          password: this.password,
        });

        swal({
          icon: "success",
          text: "Account activated successfully. Please login.",
        }).then(() => {
          this.$router.push("/");
        });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>